<template>
  <PageShell page="home" page-class="home-page" show-mobile-download>
    <div class="home-layout">
      <div class="home-main">
        <div class="article-content">
          <article ref="article" @click="handleContentClick" v-html="contentHtml" />
        </div>

        <!-- <div class="home-inline-cta">
          <button type="button" class="mv-download-btn download-trigger primary-btn" @click="downloadApk">
            <span class="mv-download-title">WhatsApp Aero APK</span>
            <span class="mv-download-sub">Download for Android</span>
          </button>
        </div> -->

        <section v-if="faqs && faqs.length" class="home-faq-block">
          <h2>Frequently Asked Questions</h2>
          <FAQ :faqs="faqs" />
        </section>
      </div>

      <aside class="home-sidebar">
        <div class="sidebar-card">
          <h3 class="sidebar-card-title">
App Information
</h3>
          <table class="sidebar-info-table">
            <tbody>
              <tr><td>App Name</td><td>WhatsApp Aero</td></tr>
              <tr><td>Version</td><td>10.90</td></tr>
              <tr><td>Size</td><td>89 MB</td></tr>
              <tr><td>Android</td><td>5.0+</td></tr>
              <tr><td>License</td><td>Free</td></tr>
              <tr><td>Category</td><td>Communication</td></tr>
              <tr><td>Updated</td><td>2026</td></tr>
            </tbody>
          </table>
          <button type="button" class="sidebar-download-btn download-trigger" @click="goDownloadPage">
            Download APK
          </button>
        </div>

        <div class="sidebar-card">
          <h3 class="sidebar-card-title">
Quick Links
</h3>
          <ul class="sidebar-links">
            <li><a href="/download/">Download Page</a></li>
            <li><a href="/features/">Features</a></li>
            <li><a href="/install-whatsapp-aero-apk/">Install Guide</a></li>
            <li><a href="/update-whatsapp-aero/">Update Guide</a></li>
            <li><a href="/how-to-stay-safe/">Anti-Ban Guide</a></li>
            <li><a href="/blog/">Blog</a></li>
          </ul>
        </div>
        <div v-if="tocItems.length" class="sidebar-card">
          <h3 class="sidebar-card-title">
On this page
</h3>
          <nav class="sidebar-toc" aria-label="Table of contents">
            <ol>
              <li v-for="item in tocItems" :key="item.id">
                <a :href="'#' + item.id" @click.prevent="scrollToHeading(item.id)">{{ item.text }}</a>
              </li>
            </ol>
          </nav>
        </div>
      </aside>
    </div>
  </PageShell>
</template>

<script>
import '@/css/home-page.scss';
import PageShell from '@/components/PageShell.vue';
import FAQ from '@/components/FAQ.vue';
import apkDownload from '@/mixins/apkDownload';
import content from '@/documents/content/home.js';
import faqs from '@/documents/content/homeFaqs.js';
import { brandAssetMap } from '@/config/brandAssets';
import aeroShot1 from '@/assets/aero/aero-shot-1.webp';
import aeroShot2 from '@/assets/aero/aero-shot-2.webp';
import aeroShot3 from '@/assets/aero/aero-shot-3.webp';
import aeroShot4 from '@/assets/aero/aero-shot-4.webp';
import aeroShot5 from '@/assets/aero/aero-shot-5.webp';

const assetMap = {
  ...brandAssetMap,
  '@/assets/aero/aero-shot-1.webp': aeroShot1,
  '@/assets/aero/aero-shot-2.webp': aeroShot2,
  '@/assets/aero/aero-shot-3.webp': aeroShot3,
  '@/assets/aero/aero-shot-4.webp': aeroShot4,
  '@/assets/aero/aero-shot-5.webp': aeroShot5,
};

export default {
  name: 'Home',
  components: { PageShell, FAQ },
  mixins: [apkDownload],
  data() {
    return {
      content,
      faqs,
    };
  },
  computed: {
    contentHtml() {
      let html = this.content;
      Object.keys(assetMap).forEach((key) => {
        html = html.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), assetMap[key]);
      });
      let sectionIndex = 0;
      html = html.replace(/<h2>/g, () => {
        sectionIndex += 1;
        return `<h2 id="section-${sectionIndex}">`;
      });
      html = this.enhanceStepHeadings(html);
      return html;
    },
    tocItems() {
      const matches = this.content.match(/<h2>([^<]+)<\/h2>/g) || [];
      return matches.map((item, index) => ({
        id: `section-${index + 1}`,
        text: item.replace(/<\/?h2>/g, ''),
      }));
    },
  },
  methods: {
    handleContentClick(e) {
      if (e.target.closest && e.target.closest('.download-trigger')) {
        this.goDownloadPage();
      }
    },
    goDownloadPage() {
      window.location.href = '/download/';
    },
    scrollToHeading(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    enhanceStepHeadings(html) {
      return html.replace(/<(h3|p)>(Step\s+(\d+))(?::\s*)?([^<]*)<\/\1>/gi, (match, tag, stepLabel, stepNumber, stepText) => {
        const text = stepText ? `<span class="article-step-text">${stepText}</span>` : '';
        return `<${tag} class="article-step-heading article-step-heading--${tag}"><span class="article-step-badge">${stepLabel}</span>${text}</${tag}>`;
      });
    },
  },
};
</script>
